import { render, staticRenderFns } from "./ProgramDetailSlider.vue?vue&type=template&id=0341559a&scoped=true&"
import script from "./ProgramDetailSlider.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetailSlider.vue?vue&type=style&index=0&id=0341559a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0341559a",
  null
  
)

export default component.exports